const req = require.context('./install', false, /\.js$/);
const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
requireAll(req);
